import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OutletTypeState {
  primaryOutletType: string | null;
  secondaryOutletType: string | null;
}

const initialState: OutletTypeState = {
  primaryOutletType: null,
  secondaryOutletType: null,
};

const outletTypeSlice = createSlice({
  name: "outletType",
  initialState,
  reducers: {
    setOutletTypes(state, action: PayloadAction<{ primary: string; secondary: string }>) {
      state.primaryOutletType = action.payload.primary;
      state.secondaryOutletType = action.payload.secondary;
    },
  },
});

export const { setOutletTypes } = outletTypeSlice.actions;
export default outletTypeSlice.reducer;